import { createSelector } from '@reduxjs/toolkit';
import memoize from 'lodash/memoize';
import sortBy from 'lodash/sortBy';

import { PublicStation } from 'types';
import { State } from './types';
import { RootState } from '../root-reducer';
/* eslint-disable no-underscore-dangle */
const rootSelector = (state: RootState): State => state.stations;

export const statusSelector = createSelector(rootSelector, (stations) => stations.status);

export const errorSelector = createSelector(rootSelector, (stations) => stations.error);

export const stationsSelector = createSelector(rootSelector, (state) => {
  return state.data ? sortBy(state.data, (station) => station.name) : [];
});

export const originStationsSelector = stationsSelector;

export const destinationStationsSelector = memoize((origin?: PublicStation) => {
  return origin
    ? createSelector(stationsSelector, (stations) =>
        stations.filter((station) => origin.connectedStations.some((code) => code === station.uicStationCode))
      )
    : createSelector(stationsSelector, () => []);
});

export const stationFromUicSelector = createSelector(
  stationsSelector,
  (data) => (uicId: string | undefined) =>
    data && data.find((dataItem: PublicStation) => dataItem.uicStationCode === uicId)
);

export default {
  statusSelector,
  errorSelector,
  originStationsSelector,
  destinationStationsSelector,
  stationFromUicSelector,
};
